import dynamic from 'next/dynamic';

// Client-only: skips SSR to avoid heavy markdown parsing on the server
// Use for non-SEO fields (unit remarks, author bio, etc.)
const MarkdownParserClient = dynamic(() => import('./MarkdownParser'), {
  ssr: false,
});

export default MarkdownParserClient;
